import styled from '@emotion/styled';
import { Button, ModalActions } from '@ui-components/neo.tax';
import { ReactComponent as AlertCircleIcon } from '@ui-components/neo.tax/dist/icons/alert-circle.svg';

export const StyledButton = styled(Button)({
  display: 'inline-block',
  textAlign: 'center',
});

export const AlertCircle = styled(AlertCircleIcon)({
  height: 48,
  width: 48,
});

export const StyledModalActions = styled(ModalActions)({
  paddingTop: 0,
});
